// import MainLogin from "@/Layouts/MainLogin";
// import { Head } from "@inertiajs/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ForgotPasswordForm from "@/Components/auth/forms/ForgotPasswordForm";
import LoginForm from "@/Components/auth/forms/LoginForm";
import SetNewPasswordForm from "@/Components/auth/forms/SetNewPasswordForm";
import VerificationCodeForm from "@/Components/auth/forms/VerificationCodeForm";
import LoginRightTop from "@/Components/auth/LoginRightTop";
import AccountVerificationModal from "@/Components/modals/AccountVerificationModal";
import EmailVerificationModal from "@/Components/modals/EmailVerificationModal";
import { updateShowBoxes } from "@/reducers/auth";

import AuthText from "./Common/AuthText";
import { resetSession } from "../../reducers/session";
/**
 * This function is the Index component of the application. It takes in authentication information, Laravel version, PHP version, and CSRF token as props. It dispatches an action to update the showBoxes state when the component mounts. It returns the JSX for the Index component, including various forms for login, password reset, and account verification.
 *
 * @param {object} auth - The authentication information
 * @param {string} laravelVersion - The version of Laravel
 * @param {string} phpVersion - The version of PHP
 * @param {string} csrf_token - The CSRF token
 * @return {JSX} The JSX for the Index component
 */

const Login = () => {
  const dispatch = useDispatch();
  const { user, showBoxes } = useSelector((state) => state.auth);
  const [authEmail, setAuthEmail] = useState("");
  useEffect(() => {
    dispatch(resetSession());
    dispatch(updateShowBoxes("login"));
  }, []);

  return (
    <>
      <div className="flex items-start gap-6 max-md:flex-col">
        <div className={`flex flex-col gap-6 max-md:w-full`}>
          {showBoxes.login ? <LoginForm setAuthEmail={setAuthEmail} /> : null}
          {showBoxes.forgot_password ? (
            <>
              <ForgotPasswordForm
                authEmail={authEmail}
                setAuthEmail={setAuthEmail}
              />
              <LoginRightTop
                href={null}
                onClick={() => {
                  dispatch(updateShowBoxes("login"));
                }}
                linkText={"Back to Login Page"}
              />
            </>
          ) : null}
          {showBoxes.verification_code ? (
            <>
              <VerificationCodeForm
                action={"ResetPassword"}
                activeBox={showBoxes.verification_code}
              />
              <LoginRightTop
                text={"Already have an account?"}
                href={null}
                onClick={() => {
                  dispatch(updateShowBoxes("login"));
                }}
                linkText={"Sign In"}
              />
            </>
          ) : null}
          {showBoxes.set_new_password ? (
            <SetNewPasswordForm action={"Reset"} />
          ) : null}
        </div>
        <AuthText />
      </div>
      <EmailVerificationModal />
      <AccountVerificationModal />
    </>
  );
};

export default Login;
